<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="`UPDATE NOTIFICATION - ${form.name}`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="update-notification-manage-popup" @submit.prevent="handleSubmit(onClickUpdateNotification)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input disabled v-model="form.name" name="name" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="departments" name="departments" rules="required" v-slot="{ errors }">
                <small class="label">Departments</small>
                <v-select multiple :clearable="false" placeholder="" v-model="form.departments" label="name"
                          :closeOnSelect="false"
                          :options="departments" :reduce="option => option.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-ro mb-3">
            <vs-button v-if="form.departments.length !== departments.length" @click.stop="onClickSelectAll" size="small" class="ml-4">Select all</vs-button>
            <vs-button v-if="form.departments.length > 0" @click.stop="form.departments = []" color="danger" size="small" class="ml-4">Clear all</vs-button>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="staff" name="staff" rules="required" v-slot="{ errors }">
                <small class="label">Staff Users</small>
                <v-select multiple :clearable="false" placeholder="" v-model="form.staff" label="name"
                          :closeOnSelect="false"
                          :options="staffs" :reduce="option => option.value" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-manage-notifications-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const CarrierRepository = RepositoryFactory.get('carrier');
const DepartmentsRepository = RepositoryFactory.get('departments');
const NotificationRepository = RepositoryFactory.get('notification');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { mapActions, mapGetters } from 'vuex';

function initialState() {
  return {
    open: false,
    id: '',
    departments: [],
    form: {
      departments: [],
      staff: []
    },
    isCreateMode: true
  }
}

export default {
  name: 'UpdateNotificationManagePopUp',
  data() {
    return initialState()
  },
  components: {
    'v-select': vSelect,
  },
  methods: {
    ...mapActions(['fetchStaffs']),
    async openPopup(id) {
      try {
        Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.id = id
        await this.fetchDepartments()
        await this.fetchStaffs()
        await this.fetchNotificationDetails()
        this.open = true;
      } catch (error) {

      }
    },
    async fetchNotificationDetails() {
      try {
          const { data } = (await NotificationRepository.getNotificationDetails(this.id)).data
          this.form = data
          this.form.departments = data.departments.map((x) => x.id)
          this.form.staff = data.staff.map((x) => x.id)
      } catch (error) {
        
      }
    },
    async fetchDepartments() {
      await this.$vs.loading({
        container: '#update-notification-manage-popup',
        scale: 0.45
      })

      try {
        const {data} = (await DepartmentsRepository.getListNoPagination()).data
        this.departments = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }

      this.$vs.loading.close('#update-notification-manage-popup > .con-vs-loading')
    },
    onClickSelectAll() {
      this.form.departments = this.departments.map((x) => x.id)
    },
    async onClickUpdateNotification() {
      const vue = this;
      await this.$vs.loading({
        container: '#update-notification-manage-popup',
        scale: 0.45
      })
      try {
        await NotificationRepository.updateNotificationManage(this.id, { departments: this.form.departments, staff: this.form.staff });
        this.showSuccessMessage('Notification manage updated successfully');
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#update-notification-manage-popup > .con-vs-loading')
    },
  },
  mixins: [SuccessMessage, ErrorMessages],
  computed: {
    ...mapGetters(['staffs'])
  }
}
</script>

<style scoped>
.add-new-carrier >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}

</style>
